/* Redy favourites (own wishlist instead of Swym) -- D&A Group (Samu), 2026-10-08, kanban 08fcdf39.
   The list lives in the visitor's browser (localStorage, key "redy-kedvencek"): no app, no monthly fee,
   no server call when a heart is tapped. Known limits: no sync between devices, and iPhone Safari clears
   script-written storage after 7 days without a visit.
   Markup hooks (snippets/redy-kedvencek-gomb.liquid, snippets/redy-kedvencek-lista.liquid):
     [data-kedvenc-gomb][data-handle]  toggles one product
     [data-kedvenc-szam]               shows the number of saved products
     [data-kedvenc-lista]              renders the saved products (wishlist page) */
(() => {
  if (window.RedyKedvencek) return;
  const KULCS = 'redy-kedvencek';
  const MAX = 60;

  const olvas = () => {
    try { const l = JSON.parse(localStorage.getItem(KULCS) || '[]'); return Array.isArray(l) ? l : []; }
    catch (e) { return []; }
  };
  const ir = (l) => {
    try { localStorage.setItem(KULCS, JSON.stringify(l.slice(0, MAX))); } catch (e) { /* private mode: the heart still toggles for this page view */ }
    document.dispatchEvent(new CustomEvent('redy-kedvencek:valtozott', { detail: { db: l.length } }));
  };
  const benne = (h) => olvas().some((x) => x.h === h);
  const valt = (h) => {
    const l = olvas();
    const i = l.findIndex((x) => x.h === h);
    if (i > -1) l.splice(i, 1); else l.unshift({ h, t: Date.now() });
    ir(l);
    return i === -1;
  };

  const gombFrissit = (g) => {
    const be = benne(g.dataset.handle);
    g.setAttribute('aria-pressed', be ? 'true' : 'false');
    const f = g.querySelector('[data-kedvenc-felirat]');
    const t = be ? g.dataset.feliratBe : g.dataset.feliratKi;
    if (f) f.textContent = t;
    else if (t) { g.setAttribute('aria-label', t); g.title = t; }
  };
  const mindetFrissit = () => {
    document.querySelectorAll('[data-kedvenc-gomb]').forEach(gombFrissit);
    const db = olvas().length;
    document.querySelectorAll('[data-kedvenc-szam]').forEach((s) => { s.textContent = db; s.hidden = db === 0; });
  };

  const listaRajzol = async (doboz) => {
    const l = olvas();
    const ures = doboz.querySelector('[data-kedvenc-ures]');
    const racs = doboz.querySelector('[data-kedvenc-racs]');
    if (ures) ures.hidden = l.length > 0;
    if (!racs) return;
    // only removals since the last draw (a heart tapped on this page): drop those cards, no new requests
    const kint = [...racs.querySelectorAll('product-card [data-kedvenc-gomb]')].map((g) => g.dataset.handle);
    if (kint.length && l.every((x) => kint.includes(x.h))) {
      racs.querySelectorAll('product-card').forEach((k) => { const g = k.querySelector('[data-kedvenc-gomb]'); if (g && !l.some((x) => x.h === g.dataset.handle)) k.remove(); });
      return;
    }
    const gyoker = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    // the same product card as on collection pages (templates/product.kartya.liquid)
    const valaszok = await Promise.all(l.map((x) => fetch(`${gyoker}products/${encodeURIComponent(x.h)}?view=kartya`)
      .then(async (r) => ({ statusz: r.status, html: r.ok ? await r.text() : '' })).catch(() => ({ statusz: 0, html: '' }))));
    // a product that no longer exists (404) leaves the list; a network error keeps it for the next visit
    const marad = l.filter((x, i) => valaszok[i].statusz !== 404);
    if (marad.length !== l.length) ir(marad);
    const kartyak = valaszok.map((v) => v.html && new DOMParser().parseFromString(v.html, 'text/html').querySelector('product-card')).filter(Boolean);
    if (ures) ures.hidden = kartyak.length > 0;
    racs.replaceChildren(...kartyak);
  };

  // GA4 recommended event (Bob, 15026). It reaches GA4 only through a GTM tag listening to the
  // "add_to_wishlist" custom event; without that tag this push does nothing.
  const meres = (g) => {
    if (!g.dataset.termekId) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: 'add_to_wishlist', ecommerce: { currency: 'HUF', value: Number(g.dataset.ar) || 0,
      items: [{ item_id: g.dataset.termekId, item_name: g.dataset.nev, price: Number(g.dataset.ar) || 0 }] } });
  };

  document.addEventListener('click', (e) => {
    const g = e.target.closest('[data-kedvenc-gomb]');
    if (!g) return;
    e.preventDefault();
    if (valt(g.dataset.handle)) meres(g);
  });
  document.addEventListener('redy-kedvencek:valtozott', () => {
    mindetFrissit();
    document.querySelectorAll('[data-kedvenc-lista]').forEach(listaRajzol);
  });
  // another tab changed the list
  window.addEventListener('storage', (e) => { if (e.key === KULCS) document.dispatchEvent(new CustomEvent('redy-kedvencek:valtozott')); });

  const indul = () => {
    mindetFrissit(); document.querySelectorAll('[data-kedvenc-lista]').forEach(listaRajzol);
    // product cards loaded later (filters, infinite scroll) get their heart state too
    new MutationObserver((m) => { if (m.some((x) => [...x.addedNodes].some((n) => n.nodeType === 1 && (n.matches('[data-kedvenc-gomb]') || n.querySelector('[data-kedvenc-gomb]'))))) mindetFrissit(); })
      .observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', indul); else indul();

  window.RedyKedvencek = { olvas, valt, benne };
})();
